/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { Router, RouteConfigLoadStart, RouteConfigLoadEnd } from '@angular/router';
// import { AnalyticsService } from './@core/utils/analytics.service';
// import { SeoService } from './@core/utils/seo.service';
// import * as FullStory from '@fullstory/browser';
// import { environment } from '../environments/environment';
@Component({
  selector: 'ngx-app',
  template: '<router-outlet style="padding: 0px;margin:0px;"></router-outlet> <div style="width: 50rem;text-align: center;margin: auto;height:20vh" *ngIf="loadingRouteConfig"> <img  src="../assets/images/saasimages/Layer 2.svg" style="margin-top:30vh" ></div>',
})
export class AppComponent implements OnInit {

  loadingRouteConfig: boolean;
  constructor(private router: Router) { }
  ngOnInit(): void {
    this.router.events.subscribe(event => {
      if (event instanceof RouteConfigLoadStart) {
        this.loadingRouteConfig = true;
      } else if (event instanceof RouteConfigLoadEnd) {
        this.loadingRouteConfig = false;
      }
    });
    // this.analytics.trackPageViews();
    // this.seoService.trackCanonicalChanges();
  }
}
